import { WorkflowStatusName } from "../items";
import { WorkflowPhaseReference } from ".";

// ワークフロー参照用model
export class WorkflowReference {
  public id: string;
  public phases: WorkflowPhaseReference[];
  public status: WorkflowStatusName;
  public createLimitDate: Date;
  public deliveryLimitDate: Date;
  public finishDate: Date;
  public isBacked: boolean;
  public isExpired: boolean;
  public lastHistoryId: string;

}
